// PageMeta — drop into any route component to swap <title> + OG image + canonical
// per page. Updates on mount/unmount so SPA navigation refreshes social previews
// for crawlers that execute JavaScript (Slack, Discord, X/Twitter, LinkedIn,
// Google's modern indexer). Static crawlers like classic Facebook still see the
// homepage default from /public/index.html.
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.liftedatthemoment.com";
const DEFAULT_DESC =
  "Lifted At The Moment — Clothing, accessories, affiliates, partners, and same-day delivery in one ecosystem.";

export default function PageMeta({
  title,
  description = DEFAULT_DESC,
  ogImage = "/og-image.png",          // path under /public, NOT full URL
  path = "",                          // canonical path, e.g. "/shop"
  twitterCard = "summary_large_image",
}) {
  const fullTitle = title
    ? `${title} | Lifted At The Moment™`
    : "Lifted At The Moment™ | Clothing, Accessories & Same-Day Delivery";
  const fullImage = ogImage.startsWith("http") ? ogImage : `${SITE_URL}${ogImage}`;
  const url = `${SITE_URL}${path || ""}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
